<template>
    <div class="revenue-pending-manage">
        <Paper class="revenue-pending-manage-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <div class="header-search-title">
                        <div class="title-text">收入预测待办完成情况</div>
                    </div>
                    <search-box ref="searchBox" :search-key="tableConfig.name" :fields="tableConfig.searchFields"
                        :showResetBtn="true" @search-change="handleSearchChange" @elementChange="handleElementChange"
                        />
                </template>
                <template v-slot:list="{ tableHeight }">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="行业" name="industry"></el-tab-pane>
                        <el-tab-pane label="分公司" name="company"></el-tab-pane>
                        <el-tab-pane label="个人" name="personal"></el-tab-pane>
                    </el-tabs>
                    <table-box class="prescreen" v-loading="revenuePendingList.tableLoading" :selection="tableConfig.selection"
                        :control="false" :columns="tableConfig[activeName+'Columns']" :height="tableConfig.height"
                        :tableData="revenuePendingList.totalData" :actions="tableConfig.actioWns" :editDisableRule="() => false"
                        :allowRowClick="false" :rows="revenuePendingList.totalData" @sort-change="handleSort">
                        <template #col-append="{col, row}">
                            <span
                            v-if="['unStartedCount','progressCount','approvalCount','rejectedCount','withdrawnCount','completedCount','totalTodoCount'].includes(col.prop)">
                                {{ row[col.prop] }}</span>
                        </template>
                    </table-box>
                </template>
                <template slot="footer">
                    <lots-pagination @size-change="revenuePendingList.sizeChange"
                        :current-page.sync="revenuePendingList.pageNo" @current-change="revenuePendingList.pageChange"
                        size="small" layout="total, sizes, prev, pager, next, jumper"
                        :total="revenuePendingList.pageTotal" />
                </template>
            </list-layout-paper>
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import Paper from '@/components/core/Paper';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import searchBox from '@/components/lots/searchBox';
import { Message } from 'element-ui';
import tableBox from '@/components/lots/tableBox/Index';
import { config } from './config.js';
import _ from 'lodash';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import bigDataLog from '@/utils/bigDataLog.js';
import {
    getRevenueForecastStatistics,
    getRevenueForecastCondition,
    listVersionByMonth
} from '@mdm/api/pendingManage/revenuePending.js';

export default {
    name: 'revenuePending',
    components: {
        lotsPagination,
        tableBox,
        Paper,
        listLayoutPaper,
        searchBox
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const tableConfig = reactive(_.cloneDeep(config));
        const activeName = ref('industry');
        class RevenueForecastListClass extends AdvanceListClass {
            beforeGetList(condition) {
                // 校验月份和版本必填
                if (!condition.periodMonth) {
                    Message.warning('请选择预测月份');
                    return false;
                }
                if (!condition.forecastVersionCode) {
                    Message.warning('请选择收入预测版本');
                    return false;
                }
                return searchDataFormat(condition);
            };
            afterGetList(res) {
                if (res && +res.code === 0) {
                    revenuePendingList.totalData.value = res.data.list || [];
                    revenuePendingList.pageTotal.value = res.data.totalCount;
                }
            };
        }
        const revenuePendingList = new RevenueForecastListClass({
            Api: {
                listApi: getRevenueForecastStatistics
            }
        });
        const searchDataFormat = (condition = {}, params = {}) => {
            condition.orderBy = orderBy.value;
            condition.orderByType = orderByType.value;
            condition.angleType = activeName.value;
            Object.keys(condition).forEach(v => {
                if (condition[v] === '' || condition[v] === undefined || condition[v] === null) {
                    delete condition[v];
                }
            });
            return { ...condition, ...params };
        };
        const orderBy = ref('');
        const orderByType = ref('');
        // 获取当前月份
        const getCurrentMonth = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            return `${year}-${month}`;
        };
        const currentMonth = ref(getCurrentMonth());
        // 根据月份查询版本列表
        // eslint-disable-next-line complexity
        const getVersionByMonth = async (periodMonth) => {
            if (!periodMonth) return;
            // 先清空版本下拉框数据
            const versionField = tableConfig.searchFields.find(f => f.fieldName === 'forecastVersionCode');
            if (versionField) {
                versionField.options = [];
            }
            // 清空搜索框中的版本值
            const currentSearchData = setupContext.refs.searchBox.searchData || {};
            setupContext.refs.searchBox.setQueryParams({
                ...currentSearchData,
                periodMonth: periodMonth,
                forecastVersionCode: undefined
            });

            const versionRes = await listVersionByMonth({ periodMonth });
            if (versionRes && +versionRes.code === 0 && versionRes.data) {
                if (versionField) {
                    versionField.options = (versionRes.data || []).map(item => ({
                        label: item?.forecastVersionCode,
                        value: item?.forecastVersion
                    }));
                    // 设置默认选第一个版本，保留其他查询条件
                    if (versionField.options.length > 0) {
                        const searchData = setupContext.refs.searchBox.searchData || {};
                        const queryParams = {
                            ...searchData,
                            periodMonth: periodMonth,
                            forecastVersionCode: versionField.options[0].value
                        };
                        setupContext.refs.searchBox.setQueryParams(queryParams);
                    }
                }
            }
        };
        const orderType = {
            ascending: 'asc',
            descending: 'desc'
        };
        const handleSort = ({ prop, order }) => {
            orderBy.value = prop;
            orderByType.value = orderType[order];
            if (!order) {
                orderBy.value = '';
                orderByType.value = '';
            }
            revenuePendingList.getList();
        };
        const handleClick = () => {
            revenuePendingList.pageNo.value = 1;
            // 使用当前搜索框的查询条件
            const searchData = setupContext.refs.searchBox.searchData || {};
            revenuePendingList.getList(searchData);
            bigDataLog.sendDetailMessageByKey(`bigData-tab-revenue-pending-${activeName.value}`);
        };
        // 搜索条件变化处理
        const handleSearchChange = (searchData) => {
            revenuePendingList.searchList(searchData);
        };
        // 元素变化处理（月份变化时更新版本下拉框）
        const handleElementChange = async({ column, searchData }) => {
            // 如果变化的字段是预测月份
            if (column.value === 'periodMonth') {
                // 如果月份为空，清空版本下拉框和值
                if (!searchData.periodMonth) {
                    const versionField = tableConfig.searchFields.find(f => f.fieldName === 'forecastVersionCode');
                    if (versionField) {
                        versionField.options = [];
                    }
                    const currentSearchData = setupContext.refs.searchBox.searchData || {};
                    setupContext.refs.searchBox.setQueryParams({
                        ...currentSearchData,
                        periodMonth: undefined,
                        forecastVersionCode: undefined
                    });
                    return;
                }
                await getVersionByMonth(searchData.periodMonth);
            }
        };

        // eslint-disable-next-line complexity
        const initSearchOptions = async() => {
            const industryRes = await getRevenueForecastCondition({ type: 'industry' });
            if (industryRes && +industryRes.code === 0 && industryRes.data) {
                const industryField = tableConfig.searchFields.find(f => f.fieldName === 'industryCategoriesCode');
                if (industryField) {
                    industryField.options = (industryRes.data.list || []).map(item => ({
                        label: item?.name,
                        value: item?.code
                    }));
                }
            }
        };
        onMounted(async() => {
            await initSearchOptions();
            // 设置当前月份并查询版本
            const monthField = tableConfig.searchFields.find(f => f.fieldName === 'periodMonth');
            if (monthField) {
                monthField.defaultValue = currentMonth.value;
            }
            const queryParams = { periodMonth: currentMonth.value };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            await getVersionByMonth(currentMonth.value);
        });
        return {
            revenuePendingList,
            tableConfig,
            activeName,
            handleClick,
            handleSort,
            handleSearchChange,
            handleElementChange
        };
    }
};
</script>

<style lang="less">
.revenue-pending-manage{
    flex: 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .revenue-pending-manage-paper{
        flex: 1 auto;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .layout-content.revenue-pending-manage-paper {
        padding: 0px 0px 0px;
    }
    .header-search-title{
        margin-bottom: 20px;
        .title-text{
            font-weight: bolder;
            font-size: 20px;
            margin-bottom: 10px;
        }
        .title-tips{
            color: #888;
            display: flex;
            align-content: center;
            .icon-pic {
                width: 14px;
                height: 14px;
                margin-left: 4px;
            }
        }
    }
    .header-button{
        margin-top: 43px;
    }
    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .list-summary-title{
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }
    .list-summary-text{
        span{
            color: #333;
            font-size: 14px;
            margin-bottom: 5px;
            line-height: 24px;
        }
    }
    .click-text {
        color: #4285f5;
        cursor: pointer;
    }
}
</style>
